import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

function pairOf(rfq) {
    const pay = String(rfq?.pay_asset || "").toUpperCase();
    const get = String(rfq?.get_asset || "").toUpperCase();
    const side = String(rfq?.side || "").toUpperCase();
    if (side === "SELL" && pay && get) return `${pay}/${get}`;
    if (get && pay) return `${get}/${pay}`;
    return "";
}

export default function OtcCancelRfqModal({ open, rfq, submitting, onConfirm, onClose }) {
    const readyAtRef = useRef(0);

    useEffect(() => {
        if (!open) return undefined;
        readyAtRef.current = Date.now() + 250;
        const onKey = (event) => {
            if (event.key === "Escape" && !submitting) onClose?.();
        };
        window.addEventListener("keydown", onKey);
        const previous = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = previous;
        };
    }, [open, onClose, submitting]);

    if (!open || !rfq || typeof document === "undefined") return null;

    const pair = pairOf(rfq);

    return createPortal(
        <div className="otc-accept-overlay" role="presentation">
            <div
                className="otc-accept-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="otc-cancel-title"
            >
                <div className="otc-accept-head">
                    <div>
                        <p className="otc-accept-kicker">Quote request</p>
                        <h2 id="otc-cancel-title">Cancel this request?</h2>
                    </div>
                    <button
                        type="button"
                        className="otc-accept-close"
                        onClick={onClose}
                        disabled={submitting}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                <p className="otc-accept-lead">
                    {pair
                        ? `This closes your ${pair} request with the desk. You can send a new one after it is cancelled.`
                        : "This closes your request with the desk. You can send a new one after it is cancelled."}
                </p>
                <div className="otc-accept-actions">
                    <button
                        type="button"
                        className="otc-accept-submit is-sell"
                        onClick={() => {
                            if (Date.now() < readyAtRef.current) return;
                            onConfirm?.();
                        }}
                        disabled={submitting}
                    >
                        {submitting ? "Cancelling…" : "Cancel request"}
                    </button>
                    <button type="button" className="otc-accept-later" onClick={onClose} disabled={submitting}>
                        Keep request
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
